var Component = require("!../../../../../vue-loader/lib/component-normalizer")(
  /* script */
  require("!!babel-loader!../../../../../vue-loader/lib/selector?type=script&index=0!./rtDetailBottom.vue"),
  /* template */
  require("!!../../../../../vue-loader/lib/template-compiler/index?{\"id\":\"data-v-869b95ca\"}!../../../../../vue-loader/lib/selector?type=template&index=0!./rtDetailBottom.vue"),
  /* scopeId */
  null,
  /* cssModules */
  null
)

module.exports = Component.exports



//////////////////
// WEBPACK FOOTER
// ./~/vue-xpc/src/components/business/detail/rtDetailBottom.vue
// module id = 1878
// module chunks = 228